export enum ZEST_MENU_TYPE {
  GITBOOK,
  RECORDING,
  MAIN,
}
